// extracted by mini-css-extract-plugin
export default {"message-row":"UserMessage_message-row__TzOb4","chat-message-container":"UserMessage_chat-message-container__tufV2"};